function Footer() {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const tenant = pathSegments[0] || '';
  const termsHref = tenant ? `/${tenant}/terms-of-use` : 'https://www.forms.service.gov.uk/terms-of-use';
  const cookiesHref = tenant ? `/${tenant}/cookies` : 'https://www.forms.service.gov.uk/cookies';
  const accessibilityHref = tenant
    ? `/${tenant}/accessibility`
    : 'https://www.forms.service.gov.uk/accessibility';
  const privacyHref = tenant
    ? `/${tenant}/privacy`
    : 'https://www.gov.uk/government/organisations/cabinet-office/about/personal-information-charter';

  return (
    <footer className="govuk-footer">
      <div className="govuk-width-container ">
        <div className="govuk-footer__meta">
          <div className="govuk-footer__meta-item govuk-footer__meta-item--grow">
            <ul className="govuk-footer__inline-list govuk-!-display-none-print">
              <li className="govuk-footer__inline-list-item">
                <a className="govuk-footer__link" href={termsHref} target="_blank" rel="noreferrer">
                  Terms of use
                </a>
              </li>
              <li className="govuk-footer__inline-list-item">
                <a className="govuk-footer__link" href={cookiesHref} target="_blank" rel="noreferrer">
                  Cookies
                </a>
              </li>
              <li className="govuk-footer__inline-list-item">
                <a className="govuk-footer__link" href={privacyHref} target="_blank" rel="noreferrer">
                  Privacy
                </a>
              </li>
              <li className="govuk-footer__inline-list-item">
                <a
                  className="govuk-footer__link"
                  target="_blank"
                  rel="noreferrer"
                  href={accessibilityHref}
                >
                  Accessibility statement
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;


